// Set up window.DEBUG
const urlParams = new Proxy(new URLSearchParams(window.location.search), {
	get: (searchParams, prop) => searchParams.get(prop as string),
})

// Figure out whether we're running in debug mode
Object.defineProperty(window, 'DEBUG', {
	value: (import.meta.env.DEV || (<any> urlParams).debug == "1337") && (<any> urlParams).debug != 'no',
	writable: import.meta.env.DEV
})